import { DecimalPipe, NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SPACE_CARD_IMAGE_SIZES } from '../../shared/storage/space-image.constants';
import { minHourlyRate, spaceCoverThumb, Space } from '../../models/asset.model';
import { spaceLocationLabel } from '../../shared/location/address-resolution.utils';
import { spacePublicPathCommands } from '../../shared/location/space-public-url.utils';

@Component({
    selector: 'app-space-card',
    imports: [RouterLink, NgOptimizedImage, DecimalPipe],
    templateUrl: './space-card.component.html'
})
export class SpaceCardComponent {
  readonly cardImageSizes = SPACE_CARD_IMAGE_SIZES;

  @Input() space!: Space;

  get coverImage(): string {
    return spaceCoverThumb(this.space);
  }

  get fromHourlyRate(): number {
    return minHourlyRate(this.space);
  }

  get detailLink(): string[] {
    return spacePublicPathCommands(this.space);
  }

  get locationLabel(): string {
    return spaceLocationLabel(this.space);
  }
}
